<template>
    <div class="custom-tree-container">
        <div class="block" style="width:100%">
            <el-tree :data="data"
                     props="defaultProps"
                     node-key="id"
                     default-expand-all
                     :expand-on-click-node="false"
                     @node-click="nodeclick"
                     @node-drag-start="handleDragStart"
                     @node-drag-enter="handleDragEnter"
                     @node-drag-leave="handleDragLeave"
                     @node-drag-over="handleDragOver"
                     @node-drag-end="handleDragEnd"
                     @node-drop="handleDrop"
                     draggable
                     :allow-drop="allowDrop">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <!-- 如果是编辑状态 -->
          <template v-if="data.isEdit==1">
            <el-input ref="input" @blur="submitEdit(node,data)" size="small" v-model="newName" style="width: 200px"></el-input>
          </template>
            <!-- 如果不是编辑状态 -->
          <span v-else v-text="data.name"></span><span>
            <el-button v-if="data.id!=1" class="el-icon-edit-outline" type="text" size="small" @click="() => edit(node,data)"></el-button>
            <el-button type="text" class="el-icon-circle-plus" size="small" @click="() => append(node,data)"></el-button>
            <el-button v-if="data.id!=1" class="el-icon-delete" type="text" size="small" @click="() => remove(node, data)"></el-button>
          </span>
        </span>
            </el-tree>
        </div>
    </div>
</template>

<script>
    import {loadData,addType,updateType,delType} from '@/api/tree/tree'
    export default {
        name: 'editTree',
        data() {
            return {
                data: [],
                newName: '',
                defaultProps: {
                    children: 'children',
                    label: 'name'
                }
            }
        },
        created() {
            this.getApiGroupData()
        },
        methods: {
            // 调api获取分组数据
            getApiGroupData(){
                loadData().then((res) => {
                    this.data=res.data;
                })
                // this.data = [{
                //     "id": 1,
                //     "name": "技术部",
                //     "level": 1,
                //     "children": [
                //         {
                //             "id": 2,
                //             "name": "运维组",
                //             "level": 2,
                //             "children": [
                //                 {
                //                     "id": 3,
                //                     "name": "godo",
                //                     "level": 3,
                //                     "children": []
                //                 }
                //             ]
                //         },
                //         {
                //             "id": 4,
                //             "name": "测试组",
                //             "level": 2,
                //             "children": []
                //         }
                //     ]
                // }]
            },
            handleDragStart(node, ev) {
                console.log('drag start', node.data.name)
            },
            handleDragEnter(draggingNode, dropNode, ev) {
                console.log('tree drag enter: ', dropNode.data.name)
            },
            handleDragLeave(draggingNode, dropNode, ev) {
                console.log('tree drag leave: ', dropNode.data.name)
            },
            handleDragOver(draggingNode, dropNode, ev) {
                console.log('tree drag over: ', dropNode.data.name)
            },
            handleDragEnd(draggingNode, dropNode, dropType, ev) {
                console.log(
                    'tree drag end: ',
                    dropNode && dropNode.data.name,
                    dropType
                )
                // 调后端更新
                // this.updateApiGroup(this.data)
            },
            handleDrop(draggingNode, dropNode, dropType, ev) {
                
                console.log('tree drop: ', dropNode.data.name, dropType)
            },
            allowDrop(draggingNode, dropNode, type) {
                
                if (dropNode.data.id === 1) {
                    return false
                } else {
                    return true
                }
            },
            allowDrag(draggingNode) {
                // 顶层默认分组不允许拖拽
                if (draggingNode.data.id === 1) {
                    return false
                } else {
                    return true
                }
                // return draggingNode.data.name.indexOf('三级 3-2-2') === -1
            },

            append(node, data) {
                // var pid = data.parentApiGroupId + ':' + data.id
                var timestamp = new Date().getTime()
                const newChild = {
                    id: null,
                    isEdit: 0,
                    name: '请输入名称',
                    typeNo:data.typeNo,  //不清楚别的平台分类编码是什么,所以新增的都加1,以免混乱
                    pTypeNo:data.id,
                    children: []
                }
                if (!data.children) {
                    this.$set(data, 'children', [])
                }
                data.children.push(newChild)
            },

            remove(node, data) {
                const parent = node.parent;
                const children = parent.data.children || parent.data;
                const index = children.findIndex(d => d.id === data.id);
                const h = this.$createElement;
                this.$msgbox({
                    title: '提示',
                    message: h('p', null, [
                        h('span', null, '确定要删除分类 '),
                        h('span', { style: 'color: red;padding: 0 5px' }, node.data.name),
                        h('span', null, '吗？')
                    ]),
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {
                    // children.splice(index, 1
                    delType(data.id).then((res) => {
                        this.msgSuccess("删除成功");
                        this.getApiGroupData();
                    })
                });
            },

            edit(node, data) {
                this.$set(data, 'isEdit', 1);
                this.newName = data.name;
                this.$nextTick(() => {
                    this.$refs.input.focus()
                });
            },

            submitEdit(node, data) {
                if (data.name == this.newName) {
                    this.newName = ''
                    this.$set(data, 'isEdit', 0)
                    return;
                } else {
                    this.$set(data, 'name', this.newName)
                    //修改的时候不是使用name字段,而是使用typeName,
                    this.$set(data, 'typeNme', this.newName)
                    this.newName = ''
                    this.$set(data, 'isEdit', 0)
                }
                if (data.id==null){
                    addType(data).then((res) => {
                        let children = node.parent.data.children;
                        //做成不全部加载,只进行单个加载
                        // children.forEach((item, index, arr) => {
                        //     if (item.name==res.data.name && item.id ==null){
                        //         res.data.level=(parseInt(node.parent.data.level)+1+"")
                        //         children.splice(index,1);
                        //         children.push(res.data);
                        //     }
                        // })
                        this.getApiGroupData();
                        this.msgSuccess("新增成功");
                    })
                }else {
                    updateType(data).then((res) => {
                        this.getApiGroupData();
                        this.msgSuccess("修改成功");
                    })
                }
            },

            cancelEdit(node, data) {
                this.newName = ''
                this.$set(data, 'isEdit', 0)
            },

            // updateApiGroup(data) {
            //     updateApiGroup(1, data)
            //         .then(response => {
            //             console.log(response)
            //         })
            //         .catch(err => {
            //             console.log(err)
            //         })
            // },

            nodeclick(node, data, obj) {
            }
        }
    }
</script>
<style>
    .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 20px;
        border-bottom: 1px solid #ccc;
        color: black;
    }
    .block .el-tree .el-tree-node .el-tree-node__content{height: 33px !important;}
</style>

